import type React from "react"
import { useEffect, useState } from "react"
import { Button, Radio, Row } from "antd"
import type { FormInstance } from "antd"

import { PlusOutlined } from "@ant-design/icons"
import DataGrid from 'components/theme_components/DataGrid';
import Title from "components/Title"
import FormInput from "components/FormInput"
import ModalSFS from "components/theme_components/ModalSFS"
import GetLabel from "DisplayFramework/components/GetLabel"
import AutomaticConversionModal from "./ProductModals/AutomaticConversionModal"
import type { ParOfferTargetConversionRequest } from "services/pricing"

export type ProductConversionProps = {
  form: FormInstance
  required: boolean
  value: ParOfferTargetConversionRequest[]
  onChange: (val: ParOfferTargetConversionRequest[]) => void
}

const ProductConversion: React.FC<ProductConversionProps> = ({ form, required, value, onChange }) => {
  const [isManualConversion, setIsManualConversion] = useState<boolean>(false)
  const [offerList, setOfferList] = useState<any[]>([])
  const [isVisible, setVisible] = useState(false)

  // Initialize state from form values
  useEffect(() => {
    const conversionFlag = form.getFieldValue('conversionFlag');
    const conversionProducts = form.getFieldValue('conversionProducts') || [];

    setIsManualConversion(conversionFlag === 'oui');
    setOfferList(conversionProducts);
  }, [form]);

  const handleRadioChange = (e: any) => {
    const isManual = e.target.value === "oui";
    setIsManualConversion(isManual);

    // Update form value
    form.setFieldsValue({ conversionFlag: e.target.value });

    // If switching to "non", clear the conversion products
    if (!isManual) {
      setOfferList([]);
      onChange([]);
      form.setFieldsValue({ conversionProducts: [] });
    }
  }
  const columns = [
    {
      dataIndex: "prcode",
      key: "prcode",
      width: "80px",
    },
    {
      dataIndex: "offercode",
      key: "offercode",
    },
    {
      dataIndex: "offerlabel",
      key: "offerlabel",
    },
  ]

  // Updated function to handle offer selection from modal
  const handleOfferSelection = (selectedOffers: any[]) => {
    const prcode = form.getFieldValue("prcode")

    // Map selected offers to conversion requests
    const mappedConversions: ParOfferTargetConversionRequest[] = selectedOffers.map((offerdata) => ({
      offerid: 0,
      producttarget: offerdata.prcode,
      offercodetarget: offerdata.offercode,
      offeridtarget: offerdata.offerid,
      offerlabel: offerdata.label ?? offerdata.offerlabel ?? "-",
    }))

    setOfferList(selectedOffers)
    onChange(mappedConversions)
    form.setFieldsValue({
      conversionProducts: mappedConversions,
    })

  }

  const isFetching = false

  return (
    <div className="container-stepper mt-4 taux productlist">
      <Title comcode="infoToCompleteConversion" level={4} className="ut-updateTP-title mb-7 mt-10" />
      <FormInput
        name="conversionFlag"
        // rules={[
        //   {
        //     required: required,
        //     message: "Veuillez sélectionner une option",
        //   },
        // ]}
        className="color-gray mb-7"
      >
        <Radio.Group onChange={handleRadioChange} value={isManualConversion}>
          <Radio value="oui" className="ml-4">
            Oui
          </Radio>
          <Radio value="non">Non</Radio>
        </Radio.Group>
      </FormInput>
      {isManualConversion && (
        <>
          <div className="mt-4">
            <DataGrid dataSource={offerList} columns={columns} isLoading={isFetching} scroll={undefined} />
          </div>

          <Row justify="center" align="middle">
            <ModalSFS
              className="color-gray"
              width={800}
              trigger={({ setVisible }) => (
                <Button
                  className="ut-reset-btn ut-btn-no-border no-box-shadow font-weight-500"
                  onClick={() => setVisible(true)}
                  icon={<PlusOutlined />}
                >
                  <GetLabel label="addProducts" />
                </Button>
              )}
              title="addProducts"
            >
              <AutomaticConversionModal
                dataConv={form.getFieldValue("conversionProducts")}
                setVisible={setVisible}
                prcode={form.getFieldValue("prcode")}
                offertarget={form.getFieldValue("offertarget")}
                handleConfirm={() => { }}
                currentSelectedOffers={offerList} // Pass current selections
                onSelectOffer={handleOfferSelection}
              />
            </ModalSFS>
          </Row>
        </>
      )}
    </div>
  )
}

export default ProductConversion
